let view = null;

export default {
	namespace: 'template-contact',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: ContactView } = await import(
			/* webpackChunkName: "contact-view" */ '../../templates/ContactView'
		);
		view = new ContactView(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
